import React, { useEffect, useRef } from 'react';

type Props = {
  indeterminate?: boolean;
} & React.HTMLProps<HTMLInputElement>;

function IndeterminateCheckbox({ indeterminate, className = '', ...rest }: Props) {
  const ref = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (typeof indeterminate === 'boolean' && ref.current) {
      ref.current.indeterminate = !rest.checked && indeterminate;
      if (indeterminate) {
        ref.current.classList.add('indeterminate');
      } else {
        ref.current.classList.remove('indeterminate');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={`${className} cursor-pointer`}
      {...rest}
      style={{ margin: 'auto' }}
    />
  );
}

export default IndeterminateCheckbox;
